import { startCase } from 'lodash';

import type { PrimaryFilterId } from '../../../filters/types/filters';

type GetFileNameProps = {
  pageName: string;
  primaryFilterId?: PrimaryFilterId;
  chartTitle?: string;
};

export const getFileName = ({
  pageName,
  primaryFilterId,
  chartTitle,
}: GetFileNameProps): string => {
  const primaryFilter = primaryFilterId
    ? startCase(primaryFilterId.toLowerCase())
    : undefined;
  const name = startCase(pageName).trim();

  const filenameParts = [primaryFilter, name].filter((part): part is string =>
    Boolean(part)
  );
  if (chartTitle) filenameParts.push(chartTitle);

  return filenameParts.join(' - ');
};
